import { OrdersRulesModel } from "../../model/ci-rule.model";

export const OrderCI_RULES_STATE_PATH = 'rules';

export class RuleStateModel {
	availableRuleSet?: any[];
	rulesSet?: any[];
	ruleSaveStatus?: RuleSaveStatus[];
	isRunningRules?: boolean;
	ordersRules?: OrdersRulesModel;
	rulesCompareInfo?: string[];
	rulesLog?: any[];
	uncheckedRules?: boolean;
	// Contains the last selected Rule
	selectedRule?: any;
	// tells if on revised field section
	onRevised?: boolean;

	constructor() {
		this.ruleSaveStatus = [];
		this.rulesSet = [];
		this.availableRuleSet = [];
		this.isRunningRules = false;
		this.ordersRules = new OrdersRulesModel();
		this.rulesCompareInfo = [];
		this.rulesLog = [];
		this.uncheckedRules = false;
		this.selectedRule = {};
	}
}

export class RuleSaveStatus {
	uiSection: string;
	canSave: boolean;
	check: number;
}
